export default {
  data() {

  },
  methods: {
    formatCurrency(number) {
      return number ? number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1."):'';
    }
  }
}